import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  icon: {
    width: 'inherit',
    height: 'inherit',
  },
}));

export default useStyles;
